import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { isArray } from "lodash";
import RootRef from "@material-ui/core/RootRef";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as selectors from "../controllers/selectors";
import { useSortReportCategory } from "../utils";

const useStyles = makeStyles({
  listReport: {
    marginTop: "16px",

    "&>li:first-child": {
      borderTop: "1px solid rgba(0, 0, 0, 0.1) !important",
    },
  },
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const SortListReport = () => {
  const css = useStyles();
  const categories = useSelector(selectors.selectReportCategories());

  const [items, setItems] = useState(categories || []);
  const { handleSortReportCategory } = useSortReportCategory();

  useEffect(() => {
    setItems(categories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories?.length]);

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    setItems(newItems);
    handleSortReportCategory(
      result?.draggableId,
      result.source.index,
      result.destination.index,
      categories
    );
  };

  if (!isArray(items)) return <></>;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <RootRef rootRef={provided.innerRef}>
            <List className={css.listReport}>
              {items?.length > 0 &&
                items?.map((item, index) => {
                  return (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <ListItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <ListItemIcon style={{ minWidth: "20px" }}>
                            <DragIndicatorIcon
                              style={{
                                width: "18px",
                                height: "18px",
                                fill: "#6d6e6f",
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={item?.name}
                            style={{ color: "#1e1f21" }}
                          />
                        </ListItem>
                      )}
                    </Draggable>
                  );
                })}
              {provided.placeholder}
            </List>
          </RootRef>
        )}
      </Droppable>
    </DragDropContext>
  );
};
export default SortListReport;

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,
  ...(isDragging && {}),
  border: "0px",
  // borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  borderBottom: "1px solid",
  borderColor: "rgba(0, 0, 0, 0.1)",
  color: "#666",
  marginBottom: 0,
  "& > div": {
    paddingLeft: 0,
  },
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "0",
  padding: "8px 4px",
});
